const glowLinePlugin = {
    id: 'glowLinePlugin',
    afterDatasetsDraw: (chart) => {
        const {ctx} = chart;
        chart.data.datasets.forEach((dataset, i) => {
            if (dataset.glow) {
                const meta = chart.getDatasetMeta(i);
                ctx.save();
                ctx.shadowColor = '#000';
                ctx.shadowBlur = 10;
                ctx.lineJoin = 'round';
                ctx.lineCap = 'round';
                ctx.lineWidth = dataset.borderWidth || 2;
                ctx.strokeStyle = dataset.borderColor || '#00ff00';
                ctx.beginPath();
                meta.data.forEach((point, index) => {
                    const {x, y} = point;
                    if (index === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                });
                ctx.stroke();
                ctx.restore();
            }
        });
    }
};

export { glowLinePlugin };